export default {
	xs: 12,
	s: 14,
	m: 16,
	l: 20,
	xl: 24,
	xxl: 36,
} as const;
